<div class="file-names">
  <div class="file" *ngFor="let projectFile of project.files; trackBy: trackEntityById" [ngClass]="{'picture-file-block': projectFile.ext==='jpg' || projectFile.ext==='jpeg' ||
		projectFile.ext==='png' || projectFile.ext==='gif' || projectFile.ext==='webp'}">
    <div class="file-icon"
         *ngIf="projectFile.ext !== 'jpg' && projectFile.ext !== 'jpeg' && projectFile.ext !== 'png' && projectFile.ext !== 'gif' && projectFile.ext !== 'webp'">
      <mat-icon class="material-icons-outlined md-18">{{getIcon(projectFile.ext)}}</mat-icon>
    </div>
    <div class="file-thumbnail"
         *ngIf="projectFile.ext === 'jpg' || projectFile.ext === 'jpeg' || projectFile.ext === 'png' || projectFile.ext === 'gif' || projectFile.ext === 'webp'"
         (click)="openFile(projectFile)">
      <img [src]="getTinyIcon(projectFile.id)">
    </div>
    <div class="file-block" [ngClass]="{'tablet-files': !isDesktop, 'mobile-files': isMobile }">
      <div class="file-name">
        <span (click)="openFile(projectFile)">{{projectFile?.name}}</span>
      </div>
      <div class="fila-infa">
        <div class="file-info">
          {{projectFile.user.username}},
        </div>

        <div class="file-info">
          {{projectFile.uploadTime | date: 'MMM dd, yyyy'}}
        </div>

        <div class="file-info" *ngIf="projectFile.clazz === 'ACTIVITY_FILE'">
          for {{projectFile.activityType.name}}
        </div>

        <div class="file-info check-item-info" *ngIf="isDesktop && projectFile.clazz === 'CHECKITEM_FILE'"
             pTooltip="{{projectFile.checkItemName}}" tooltipPosition="bottom">
          for CheckItem
        </div>

        <div class="file-info check-item-info" *ngIf="!isDesktop && projectFile.clazz === 'CHECKITEM_FILE'">
          for {{projectFile.checkItemName}}
        </div>
      </div>

    </div>

    <span class="delete-icon" (click)="deleteFile(projectFile)">
			<mat-icon>clear</mat-icon>
		</span>
  </div>
</div>

<mat-progress-bar *ngIf="progressBar > 0" mode="determinate" value="{{progressBar}}">
</mat-progress-bar>

<p-fileUpload mode="advanced" name="files" #filesForm (onProgress)="onProgress($event)" [customUpload]="true"
              (uploadHandler)="uploadFile($event.files, filesForm)" [auto]="true" [multiple]="true"
              chooseLabel="Upload">
  <ng-template pTemplate="content">
    <div class="attachments-block" (click)="chooseFile()">
      <i class="pi pi-download" style="font-size: 130%; margin-bottom: 0.4em;"></i>
      <div>
        <span class="add-attachment">Choose a file</span>
        <span class="drop-here"> or drag it here.</span>
      </div>
    </div>
  </ng-template>
</p-fileUpload>

<!-- <input type="file" class="my" id="myfile" name="files" multiple (change)="testEventHandler($event)"> -->
